import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-language-services-publishing-and-media',
  templateUrl: './language-services-publishing-and-media.component.html',
  styleUrls: ['./language-services-publishing-and-media.component.scss']
})
export class LanguageServicesPublishingAndMediaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka 企業版｜語言服務、出版與媒體");
    this.metaTagService.updateTag({ name: 'description', content: "讓您的團隊保持一致的寫作風格，加快出版速度，提升客戶體驗，降低寫作時間與成本，同時確保表達清晰無誤" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka 企業版｜語言服務、出版與媒體" });
    this.metaTagService.updateTag({ property: 'og:description', content: "讓您的團隊保持一致的寫作風格，加快出版速度，提升客戶體驗，降低寫作時間與成本，同時確保表達清晰無誤" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });
  }


  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/alternet.png", "altText": "alternet" },
    { "imgSrc": "/assets/images/client_logos/HarperCollinsPublishers.png", "altText": "Harper Collins Publishers" },
    { "imgSrc": "/assets/images/client_logos/scholastic.png", "altText": "scholastic" },
    { "imgSrc": "/assets/images/client_logos/sanchini.png", "altText": "sanchini" },
    { "imgSrc": "/assets/images/client_logos/technica.png", "altText": "technica" },
    { "imgSrc": "/assets/images/client_logos/CapstoneWriting.png", "altText": "Capstone Writing" },
    { "imgSrc": "/assets/images/client_logos/evolution_editing.png", "altText": "evolution editing" }
  ];
}
